import { LinkOutlined } from '@ant-design/icons';
import { Button, ButtonHierarchies } from '@clockout-dev/design-elements';
import SectionCard from '../../common/sectionCard/SectionCard';
import UserCardRow from '../../users/user/elements/UserCardRow';
import styles from '../styles/ticket-details-card.module.scss';

/**
 * Card showing linked event (e.g., review) if ticket was created from an event.
 * Displayed in ticket detail sidebar.
 *
 * @param {Object} props
 * @param {Object} props.linkedEvent - { eventId, eventName, eventDate: { year, month, day } }
 * @param {Function} props.onGoToEvent - Callback to navigate to the event
 * @param {Boolean} props.canAccessReviews - Whether the user has access to reviews (Admin/Owner only)
 */
function TicketLinkedEventCard({ linkedEvent, onGoToEvent, canAccessReviews = false }) {
    if (!linkedEvent) return null;

    const eventDate = linkedEvent.eventDate
        ? `${linkedEvent.eventDate.year}-${String(linkedEvent.eventDate.month).padStart(2, '0')}-${String(linkedEvent.eventDate.day).padStart(2, '0')}`
        : '—';

    return (
        <SectionCard icon={<LinkOutlined />} title="Linked Event">
            <div className={styles.rows}>
                <UserCardRow label="Event" value={linkedEvent.eventName || '—'} />
                <UserCardRow label="Date" value={eventDate} />
                {canAccessReviews && (
                    <UserCardRow
                        label="Action"
                        value={
                            <Button
                                type="button"
                                hierarchy={ButtonHierarchies.LINK_COLOR}
                                onClick={onGoToEvent}
                            >
                                Go to review
                            </Button>
                        }
                    />
                )}
            </div>
        </SectionCard>
    );
}

export default TicketLinkedEventCard;
